import { IconChevronDropdownDown } from '@doltech/icons/IconChevronDropdownDown';
import { Select, SelectProps } from 'antd';
import * as React from 'react';
import styled from 'styled-components';

const DolSelect = styled(Select)`
  font-weight: 500;
  width: 100%;
  height: 46px;
  font-size: 14px;
  line-height: 20px;
  input {
    height: 46px;
  }
  .ant-select-selection-search {
    display: inline-grid;
    align-items: center;
  }
  > .ant-select-arrow {
    top: calc(50% - 6px);
    right: 6px;
    font-size: 24px;
    line-height: 0;
    width: 24px;
    height: 24px;
  }
  &.ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    margin-right: 14px;
    height: 46px;
  }
`;

export const DolSelectComponent = (props: SelectProps<any>) => {
  const { suffixIcon = <IconChevronDropdownDown />, children } = props;
  return (
    <DolSelect suffixIcon={suffixIcon} {...props}>
      {children}
    </DolSelect>
  );
};
